window.addEventListener('customily-options-loaded', function (e) {
   $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
  $('#cl_optionsapp .customily_option.ropechain .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.ropechain .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
  $('#cl_optionsapp .customily_option.chainstyle .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.chainstyle .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
    $('.customily_option.Backbuckle input.needsclick.needsfocus, .customily_option.textcolor input.needsclick.needsfocus').each(function(){
      var label_txt = $(this).val();
      $(this).next('label').after('<span class="label-txt">' + label_txt + '</span>');
  });
});

$('body').on('click', '.customily_option.Backbuckle .swatch.customily-swatch', function () {
    setTimeout(function () {
      $('.customily_option.Backbuckle input.needsclick.needsfocus, .customily_option.textcolor input.needsclick.needsfocus').each(function(){
         $(this).next('label').next('span.label-txt').remove();
          var label_txt = $(this).val();
          $(this).next('label').after('<span class="label-txt">' + label_txt + '</span>');
      });
      $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
    }, 50);
});
$('body').on('click', '.customily_option.chainstyle .swatch.customily-swatch', function () {
    setTimeout(function () {
      $('#cl_optionsapp .customily_option.ropechain .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.ropechain .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
    }, 50);
});

$($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
  	var tabName = $(this).text().trim();
  	var tabContent = '';
  	var uniqueId = 'description-' + i;

 	if (tabName !== '') {
      	$(this).hide();

        $(this).nextUntil('h6').each(function() {
            tabContent += this.outerHTML;
            $(this).hide();
        });

        var accordionItem = `
        <div class="collapsible-container">
          <button type="button" class="collapsible-trigger collapsible-trigger-btn collapsible--auto-height collapsible-trigger-btn--borders" aria-controls="${uniqueId}" aria-expanded="false">
            <h4>
              ${tabName}
              <span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down icon--line" viewBox="0 0 28 16" width="20" height="20">
                  <path fill="none" stroke="currentColor" d="m1.57 1.59 12.76 12.77L27.1 1.59"></path>
                </svg>
              </span>
            </h4>
          </button>
          <div id="${uniqueId}" class="collapsible-content collapsible-content--all" hidden>
            <div class="product-single__accordion__item-wrap rte">${tabContent}</div>
          </div>
        </div>`;

        $('.js-accordion').prepend(accordionItem);
    } else {
        $(this).hide();
    }
});

// ✅ Updated: Only one tab open at a time
$(document).on('click', '.product-single__accordion .collapsible-trigger', function () {
  const $btn = $(this);
  const targetId = $btn.attr('aria-controls');
  const $content = $('#' + targetId);
  const isOpen = $btn.hasClass('is-open');

  // Step 1: Close all
  $('.collapsible-trigger').removeClass('is-open').attr('aria-expanded', 'false');
  $('.collapsible-content').removeClass('is-open').attr('hidden', true);

  // Step 2: Open only if not already open
  if (!isOpen) {
    $btn.addClass('is-open').attr('aria-expanded', 'true');
    $content.addClass('is-open').removeAttr('hidden');
  }
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-single__content-text p").forEach(function (el) {
    const content = el.innerHTML.replace(/&nbsp;/gi, '').trim();

    if (content === "") {
      el.style.display = "none";
    }
  });
});

 document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("strong").forEach(function (el) {
    const plainText = el.textContent.replace(/\s+/g, '').toLowerCase();

    if (plainText === "emailorder") {
      el.innerHTML = "Email Order"; // Insert with real space
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cstm-des-div.product-single__content .product-single__accordion__item-wrap.rte p').forEach(function (p) {
    const html = p.innerHTML.replace(/&nbsp;|\s/g, '').trim(); // Remove nbsp and spaces
    if (html === '') {
      p.style.margin = '0';
      p.style.padding = '0';
      p.style.lineHeight = '0';
      p.innerHTML = ''; // Optional: clear the inner HTML
    }
  });
});

